import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AuthState } from '../../../../state/auth';
import { AppState } from '../../../../state/configureStore';

import { Box, makeStyles, Paper, TablePagination, Typography } from '@material-ui/core';
import { ISort, PageFilter } from '../../../../state/app';
import { DateTimeDisplay } from '../../../components/DateTimeDisplay';
import TaskAndSubtaskLinkButton from '../../../components/TaskAndSubtaskLinkButton';
import {
  fetchTaskActivityListRelatedToUserId,
  clearCommentDashboard,
} from './commentDashboard.actions';
import { CommentDashboardState } from './commentDashboard.reducer';
import { DisplayHtmlContent } from '../../../components';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
  },
  comment: {
    margin: theme.spacing(1),
    padding: theme.spacing(0.5),
  },
}));

const Dashboard = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { userId } = useSelector<AppState, AuthState>((state) => state.auth);
  const { items: taskActivityList, totalItems } = useSelector<
    AppState,
    CommentDashboardState
  >((state) => state.commentDashboard);
  const [paging, setPaging] = useState<PageFilter>({
    pageNumber: 0,
    pageSize: 10,
  });
  const sort: ISort = useMemo(() => ({ orderBy: 'createdAt', direction: 'desc' }), []);

  const handleChangePageNumber = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    newPage: number,
  ) => {
    setPaging({ ...paging, pageNumber: newPage });
  };

  const handleChangePageSize = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setPaging({
      ...paging,
      pageSize: +event.target.value,
      pageNumber: 0,
    });
  };

  useEffect(() => {
    if (userId) {
      dispatch(fetchTaskActivityListRelatedToUserId(userId, { ...paging, sort }));
    }
    return function cleanup() {
      dispatch(clearCommentDashboard());
    };
  }, [dispatch, userId, paging, sort]);
  return (
    <Paper className={classes.root} elevation={2}>
      <Typography variant="h6">Last 10 days comments</Typography>
      {taskActivityList.map((taskActivity) => {
        return (
          <Paper className={classes.comment} key={taskActivity.id} elevation={3}>
            <Box m={1}>
              <Typography component="span" variant="caption">
                <Box fontWeight={500}>
                  <TaskAndSubtaskLinkButton taskActivity={taskActivity} />
                  {taskActivity.user!.fullName}
                  {' at '}
                  {<DateTimeDisplay value={taskActivity.createdAt} />}
                </Box>
              </Typography>
            </Box>
            <Box m={1}>
              <DisplayHtmlContent>{taskActivity.comment!}</DisplayHtmlContent>
            </Box>
          </Paper>
        );
      })}
      <TablePagination
        rowsPerPageOptions={[10, 15, 20]}
        component="div"
        count={totalItems}
        rowsPerPage={paging.pageSize}
        page={paging.pageNumber}
        onPageChange={handleChangePageNumber}
        onRowsPerPageChange={handleChangePageSize}
        labelRowsPerPage="Comments per page"
      />
    </Paper>
  );
};

export default Dashboard;
